// extracted by mini-css-extract-plugin
module.exports = {"submit":"buttons_submit__2dkSz","wrapSave":"buttons_wrapSave__1BYsf","row":"buttons_row__21yLl"};